/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Org_DpoInputs */

const en_privacy_org_dpo = /** @type {(inputs: Privacy_Org_DpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Protection Contact`)
};

const de_privacy_org_dpo = /** @type {(inputs: Privacy_Org_DpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutz-Ansprechpartner`)
};

const fr_privacy_org_dpo = /** @type {(inputs: Privacy_Org_DpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Délégué à la protection des données`)
};

const es_privacy_org_dpo = /** @type {(inputs: Privacy_Org_DpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delegado de protección de datos`)
};

const it_privacy_org_dpo = /** @type {(inputs: Privacy_Org_DpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabile della protezione dei dati`)
};

const nl_privacy_org_dpo = /** @type {(inputs: Privacy_Org_DpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Functionaris voor gegevensbescherming`)
};

const pl_privacy_org_dpo = /** @type {(inputs: Privacy_Org_DpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspektor ochrony danych`)
};

const fi_privacy_org_dpo = /** @type {(inputs: Privacy_Org_DpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietosuojavastaava`)
};

const da_privacy_org_dpo = /** @type {(inputs: Privacy_Org_DpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Databeskyttelsesrådgiver`)
};

const sv_privacy_org_dpo = /** @type {(inputs: Privacy_Org_DpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataskyddsombud`)
};

/**
* | output |
* | --- |
* | "Data Protection Contact" |
*
* @param {Privacy_Org_DpoInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_org_dpo = /** @type {((inputs?: Privacy_Org_DpoInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Org_DpoInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_org_dpo(inputs)
	if (locale === "fr") return fr_privacy_org_dpo(inputs)
	if (locale === "es") return es_privacy_org_dpo(inputs)
	if (locale === "it") return it_privacy_org_dpo(inputs)
	if (locale === "nl") return nl_privacy_org_dpo(inputs)
	if (locale === "pl") return pl_privacy_org_dpo(inputs)
	if (locale === "fi") return fi_privacy_org_dpo(inputs)
	if (locale === "da") return da_privacy_org_dpo(inputs)
	if (locale === "sv") return sv_privacy_org_dpo(inputs)
	return en_privacy_org_dpo(inputs)
});